import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Modules
import { config } from '@/lib/config';
import { log } from '@/lib/log';

export const Redirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let target;

    switch (true) {
      case window.location.hostname.endsWith('.at'):
      case window.location.hostname === 'localhost':
        target = 'https://abo.derstandard.at';
        break;

      case window.location.hostname.endsWith('.builders'):
        target = 'https://abo.derstandard.builders';
        break;

      case window.location.hostname.endsWith('.works'):
        target = 'https://abo.derstandard.works';
        break;

      default:
        log('Change route to', config.routes.error);
        navigate(config.routes.error);

        return;
    }

    window.location.replace(target);
  }, [navigate]);

  return null;
};

export default Redirect;
